import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { DateUtil } from '../util';

class BaseBody extends React.Component{

    static defaultProps = {
        rowNum: 0,
        colNum: 0,
    }

    _renderBody = () => {
        const { 
            rowNum, 
            colNum, 
            firstShowDate, 
            renderCellTitle, 
            renderCellNode, 
            renderCellContent, 
            calculateCellDate, 
            mode, 
            getRowClassName, 
            disabledDate, 
            getCellClassName, 
            prefixColumn, 
            viewDate,
        } = this.props;
        let rows = [];
        for(let rowIdx = 0; rowIdx < rowNum; rowIdx++){
            let row = [];
            let rowStartDate;
            for(let colIdx = 0; colIdx < colNum; colIdx++){
                let offset = rowIdx * colNum + colIdx; //获取本单元格的基于第一格单元格的偏移量
                let currentDate = calculateCellDate(firstShowDate, offset);
                let showDate = renderCellNode ? renderCellNode(currentDate) 
                    : renderCellContent ? renderCellContent(currentDate) 
                        : currentDate; /* 顺序：自定义的渲染节点 自定义的渲染内容 日期本身 */
                let disableCurrentDate = DateUtil.getCellDateDisabled(currentDate, mode, disabledDate);
                if(colIdx === 0){
                    rowStartDate = currentDate;
                    if(prefixColumn) {
                        row.push(prefixColumn(currentDate));
                    }
                }
                let title = renderCellTitle && renderCellTitle(currentDate);
                let key = `${rowIdx}-${colIdx}`;
                // console.log('========', rowNum, colNum, firstShowDate, offset, showDate, mode, currentDate, title);
                let userClass = getCellClassName && getCellClassName(currentDate);
                let tdClass = { 
                    'picker-cell': true, 
                    'picker-cell-disabled': disableCurrentDate,
                    'picker-cell-start': showDate === '1' || mode === 'year' && Number(title) % 10 === 0,
                    'picker-cell-end': showDate === `${DateUtil.getDate(DateUtil.getMonthLastDay(currentDate))}` ||
                        mode === 'year' && Number(title) % 10 === 9,
                    'picker-cell-in-view': DateUtil.isCurrentRange(currentDate, viewDate, mode),
                    'picker-cell-today': DateUtil.isSame(currentDate, new Date(), mode),
                }; 
                row.push(
                    <td 
                        key={key}
                        title={title} 
                        onClick={disableCurrentDate ? undefined : this.handleTdClick.bind(this, currentDate)} 
                        onMouseEnter={disableCurrentDate ? undefined : this.handleTdMouseEnter.bind(this, currentDate)} 
                        onMouseLeave={disableCurrentDate ? undefined : this.handleTdMouseLeave.bind(this, currentDate)}
                        className={classnames(tdClass, userClass)}
                    >
                        <div className="picker-cell-inner">{showDate}</div>
                    </td>,
                );
            }
            let trProps = {};
            if(getRowClassName){
                trProps.className = classnames(getRowClassName(rowStartDate));
            }
            rows.push(<tr {...trProps}>{row}</tr>);
        }
        return rows;
    }

    handleTdClick = (date, event) => {
        const { onSelect } = this.props;
        onSelect?.(date, event);
    }

    handleTdMouseEnter = date => {
        const { onDateMouseEnter } = this.props;
        return onDateMouseEnter && onDateMouseEnter(date);
    }

    handleTdMouseLeave = date => {
        const { onDateMouseLeave } = this.props;
        return onDateMouseLeave && onDateMouseLeave(date);
    }

    render(){
        const { renderTableHeader } = this.props;
        let rows = this._renderBody();
        return (
            <div className="picker-panel-body">
                <table>
                    {
                        renderTableHeader ? <thead><tr>{
                            Array.isArray(renderTableHeader) ? renderTableHeader.map((cell, idx) => <th key={idx}>{cell}</th>) : renderTableHeader
                        }</tr></thead> : ''
                    }
                    <tbody>{rows}</tbody>
                </table>
            </div>
        );
    }
}

BaseBody.propTypes = {
    rowNum: PropTypes.number, /* table的行数 */
    colNum: PropTypes.number, /* table的列数 */
    firstShowDate: PropTypes.object.isRequired, /* table第一格显示的日期, Date类型 */
    calculateCellDate: PropTypes.func.isRequired, /* 计算日期的方法，入参是当前日期、偏移值 */
    renderTableHeader: PropTypes.object, /* 表头，暂时只有周一到周日的显示需求 */
    renderCellNode: PropTypes.func, /* 自定义的渲染，整个结构的渲染 */
    renderCellContent: PropTypes.func, /* 自定义的渲染内容，仅改变渲染的显示 */
    renderCellTitle: PropTypes.func, /* 当鼠标放在格子上的显示，即title属性 */
    mode: PropTypes.string, /* 面板类型  month year week time date */
    getRowClassName: PropTypes.func, /* 自定义的table行样式 */
    getCellClassName: PropTypes.func, /* 自定义的table列样式 */
    disableDate: PropTypes.func, /* 不可用日期的判定方法 */
    prefixColumn: PropTypes.func, /* 需要插入table首列的渲染方法 */
    viewDate: PropTypes.object, /* 面板的基准日期，也可理解为当前日期组件渲染的基准日期, Date类型 */
    onSelect: PropTypes.func, /* 选中的回调 */
    onDateMouseEnter: PropTypes.func,
    onDateMouseLeave: PropTypes.func,
};

export default BaseBody;